import { makeStyles } from '@material-ui/core/styles';
import { drawerWidth } from 'constants/index';

export const useStyles = makeStyles((theme) => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    ...theme.mixins.toolbar,
    padding: '0 8px',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundImage: 'linear-gradient(to bottom, #3c3f48, #35363d, #2d2e32, #262628, #1e1e1e)',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  containerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundImage: 'linear-gradient(to bottom, #3c3f48, #35363d, #2d2e32, #262628, #1e1e1e)',
  },
  containerLogo: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
  },
  logo: {
    height: '20px',
  },
  menuIcon: {
    color: '#fff',
  },
  itemList: {
    borderRadius: '8px',
    transition: 'background 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      background: 'linear-gradient(90deg, rgba(2,203,244,1) 59%, rgba(0,153,235,1) 100%)',
      color: '#fff',
      boxShadow: 'inset 0px 0px 10px rgba(0, 0, 0, 0.3)',
    },
  },
  itemIcon: {
    color: '#ffff',
  },
  itemText: {
    fontSize: '14px',
    color: '#ffff',
  },
}));
